import { useForm, Link, usePage, Head } from '@inertiajs/react'
import Logo from '@/components/Logo'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import type { FormEvent, ReactNode } from 'react'

export default function OrganizationPasswordResetEdit({ token }: { token: string }) {
  const { errors } = usePage<{ errors: Record<string, string> }>().props
  const { data, setData, patch, processing } = useForm({
    password: '',
    password_confirmation: '',
  })

  function submit(e: FormEvent) {
    e.preventDefault()
    patch(`/organizations/password_resets/${token}`)
  }

  return (
    <>
      <Head title="Set New Organization Password" />
      <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-background via-accent/10 to-primary/5 px-4">
        <div className="w-full max-w-sm">
          <div className="mb-8 flex justify-center">
            <Logo />
          </div>
          <Card>
            <CardHeader className="text-center">
              <CardTitle className="text-3xl font-semibold">Set new password</CardTitle>
              <CardDescription>Choose a new password for your organization account</CardDescription>
            </CardHeader>
            <CardContent>
              <form onSubmit={submit} className="space-y-4">
                {errors.base && (
                  <p className="text-base text-destructive">{errors.base}</p>
                )}

                <div className="space-y-2">
                  <Label htmlFor="password">New password</Label>
                  <Input
                    id="password"
                    type="password"
                    value={data.password}
                    onChange={e => setData('password', e.target.value)}
                    autoComplete="new-password"
                    autoFocus
                  />
                  {errors.password && (
                    <p className="text-base text-destructive">{errors.password}</p>
                  )}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="password_confirmation">Confirm new password</Label>
                  <Input
                    id="password_confirmation"
                    type="password"
                    value={data.password_confirmation}
                    onChange={e => setData('password_confirmation', e.target.value)}
                    autoComplete="new-password"
                  />
                  {errors.password_confirmation && (
                    <p className="text-base text-destructive">{errors.password_confirmation}</p>
                  )}
                </div>

                <Button type="submit" className="w-full" disabled={processing}>
                  Reset Password
                </Button>
              </form>
            </CardContent>
            <CardFooter className="flex flex-col gap-2 text-center text-base">
              <p>
                <Link href="/organizations/sign_in" className="underline underline-offset-4 hover:text-primary">
                  Back to sign in
                </Link>
              </p>
            </CardFooter>
          </Card>
        </div>
      </div>
    </>
  )
}

OrganizationPasswordResetEdit.layout = (page: ReactNode) => page
